import React from "react";
import BaseModal from "./BaseModal";
import { TriangleAlert } from "lucide-react";

const OnaddressRangeModal = ({ open, onClose, onConfirm }) => {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className="px-8 py-7 text-center">
        {/* Icon */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-2xl bg-gradient-to-br from-[#FFF1ED] to-[#FFE4DC] shadow-sm">
          <TriangleAlert
            className="text-[#FF6943]"
            size={30}
            strokeWidth={2.2}
          />
        </div>

        {/* Heading */}
        <h2 className="mt-5 text-xl font-semibold text-gray-900 tracking-tight">
          Address Outside Delivery Range
        </h2>

        {/* Sub text */}
        <p className="mt-3 text-sm text-gray-500 leading-relaxed max-w-sm mx-auto">
          The selected address falls beyond our delivery coverage area. You may
          choose another address within range or proceed with this one at your
          discretion.
        </p>

        {/* Divider */}
        <div className="h-px bg-gray-100 my-6" />

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all duration-200"
          >
            Change Address
          </button>

          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl bg-gradient-to-r from-[#FF6943] to-[#ff8a6d] text-white font-semibold shadow-md   active:scale-[0.98] transition-all duration-200"
          >
            Continue Anyway
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default OnaddressRangeModal;
